import isEmpty from 'lodash/isEmpty'
import pick from 'lodash/pick'
import { BusinessType } from 'src/types/business'

export const getBusinessContextValue = (config: unknown) => {
  const contextValue = pick(config, ['mobileRate', 'affiliateId', 'utmMedium', 'rateModel']) as {
    mobileRate: boolean
    affiliateId: string
    utmMedium: string
    rateModel?: string
  }

  if (isEmpty(contextValue)) {
    return null
  }

  const { mobileRate, affiliateId, utmMedium, rateModel } = contextValue

  return { mobileRate, affiliate: affiliateId, utmMedium, rateModel } as BusinessType
}
